
// import React, { useEffect, useState } from 'react';
// import { config } from '../CommonUtils/CommonURLS';
// import { CommonAxiosGet } from '../CommonUtils/CommonAxios';
// import CommonReactTable from '../CommonUtils/CommonReactTable';
// import { FaArrowLeft, FaUsers } from 'react-icons/fa';

// export default function FacultyDashboardReport() {
//    const userId = sessionStorage.getItem("user_id");

// const key = userId?.startsWith("U-")
//     ? userId.split("_")[0]
//     : "all";

// console.log("API Key:", key);
//     const [dashboard, setDashboard] = useState([]);
//     const [collegeDashboard, setCollegeDashboard] = useState([]);
//     const [employeeDetails, setEmployeeDetails] = useState([]);

//     const [selectedUniversity, setSelectedUniversity] = useState(null);
//     const [selectedCollege, setSelectedCollege] = useState(null);
//     const [selectedEmpType, setSelectedEmpType] = useState('');

//     const [loading, setLoading] = useState(false);

//     // LEVEL 1: University dashboard
//     function GetDashboardData() {
//         setLoading(true);

//         CommonAxiosGet(
//             `${config.url.FAC_URL}getunivdashboard/${key}`
//         )
//             .then((res) => {
//                 setDashboard(
//                     res?.data?.scode === '01'
//                         ? res.data.data || []
//                         : []
//                 );
//             })
//             .catch((error) => {
//                 console.error('Error fetching university dashboard:', error);
//                 setDashboard([]);
//             })
//             .finally(() => {
//                 setLoading(false);
//             });
//     }

//     useEffect(() => {
//         GetDashboardData();
//     }, []);

//     // LEVEL 2: College dashboard
//     function GetCollegeDashboard(university) {
//         const ubCode = university?.aishe_code;

//         if (!ubCode) {
//             alert('AISHE Code is not available for this university.');
//             return;
//         }

//         setSelectedUniversity(university);
//         setSelectedCollege(null);
//         setSelectedEmpType('');
//         setCollegeDashboard([]);
//         setEmployeeDetails([]);
//         setLoading(true);

//         CommonAxiosGet(
//             `${config.url.FAC_URL}getunivdashboardcollges/${encodeURIComponent(ubCode)}`
//         )
//             .then((res) => {
//                 setCollegeDashboard(
//                     res?.data?.scode === '01'
//                         ? res.data.data || []
//                         : []
//                 );
//             })
//             .catch((error) => {
//                 console.error('Error fetching college dashboard:', error);
//                 setCollegeDashboard([]);
//             })
//             .finally(() => {
//                 setLoading(false);
//             });
//     }

//     // LEVEL 3: Employee details by college and employee type
//     function GetCollegeEmployees(college, empType) {
//         console.log("ddddddddd",college,empType)
//         const collCode = college?.coll_code;

//         if (!collCode) {
//             alert('College code is not available.');
//             console.error('Selected college data:', college);
//             return;
//         }

//         setSelectedCollege(college);
//         setSelectedEmpType(empType);
//         setEmployeeDetails([]);
//         setLoading(true);

//         CommonAxiosGet(
//             `${config.url.FAC_URL}getunivdashboadcollegesemployees/${encodeURIComponent(collCode)}/${empType}`
//         )
//             .then((res) => {
//                 setEmployeeDetails(
//                     res?.data?.scode === '01'
//                         ? res.data.data || []
//                         : []
//                 );
//             })
//             .catch((error) => {
//                 console.error('Error fetching employee details:', error);
//                 setEmployeeDetails([]);
//             })
//             .finally(() => {
//                 setLoading(false);
//             });
//     }

//     // LEVEL 1: University columns
//     const columns = [
//         {
//             id: 'slNo',
//             header: 'Sl.No',
//             cell: ({ row }) => row.index + 1,
//         },
//         {
//             id: 'univ_name',
//             header: 'University Name',
//             accessorKey: 'univ_name',
//             cell: ({ row }) => row.original.univ_name || '-',
//         },
//         {
//             id: 'teaching',
//             header: 'Teaching Faculty',
//             accessorKey: 'teaching',
//             cell: ({ row }) => (
//                 <button
//                     type="button"
//                     className="faculty-count-btn teaching-count"
//                     onClick={() => GetCollegeDashboard(row.original)}
//                     title="View college-wise teaching faculty counts"
//                 >
//                     <FaUsers size={13} />
//                     {row.original.teaching ?? 0}
//                 </button>
//             ),
//             meta: { style: { textAlign: 'center' } },
//         },
//         {
//             id: 'nonteaching',
//             header: 'Non-Teaching Faculty',
//             accessorKey: 'nonteaching',
//             cell: ({ row }) => (
//                 <button
//                     type="button"
//                     className="faculty-count-btn nonteaching-count"
//                     onClick={() => GetCollegeDashboard(row.original)}
//                     title="View college-wise non-teaching faculty counts"
//                 >
//                     <FaUsers size={13} />
//                     {row.original.nonteaching ?? 0}
//                 </button>
//             ),
//             meta: { style: { textAlign: 'center' } },
//         },
//     ];

//     // LEVEL 2: College columns
//     const collegeColumns = [
//         {
//             id: 'slNo',
//             header: 'Sl.No',
//             cell: ({ row }) => row.index + 1,
//         },
//         {
//             id: 'coll_name',
//             header: 'College Name',
//             accessorKey: 'coll_name',
//             cell: ({ row }) => row.original.coll_name || '-',
//         },
//         {
//             id: 'teaching',
//             header: 'Teaching Faculty',
//             accessorKey: 'teaching',
//             cell: ({ row }) => (
//                 <button
//                     type="button"
//                     className="faculty-count-btn teaching-count"
//                     onClick={() =>
//                         GetCollegeEmployees(row.original, 'teaching')
//                     }
//                     title="View teaching employees"
//                 >
//                     <FaUsers size={13} />
//                     {row.original.teaching ?? 0}
//                 </button>
//             ),
//             meta: { style: { textAlign: 'center' } },
//         },
//         {
//             id: 'nonteaching',
//             header: 'Non-Teaching Faculty',
//             accessorKey: 'nonteaching',
//             cell: ({ row }) => (
//                 <button
//                     type="button"
//                     className="faculty-count-btn nonteaching-count"
//                     onClick={() =>
//                         GetCollegeEmployees(row.original, 'nonteaching')
//                     }
//                     title="View non-teaching employees"
//                 >
//                     <FaUsers size={13} />
//                     {row.original.nonteaching ?? 0}
//                 </button>
//             ),
//             meta: { style: { textAlign: 'center' } },
//         },
//     ];

//     // LEVEL 3: Employee columns
//     // Adjust accessor keys if the employee API returns different field names.
//    const employeeColumns = [
//     {
//         id: "slNo",
//         header: "Sl. No.",
//         cell: ({ row }) => row.index + 1,
//     },
//     {
//         id: "description_long",
//         header: "University",
//         accessorKey: "description_long",
//     },
//     {
//         id: "cfms_id",
//         header: "CFMS ID",
//         accessorKey: "cfms_id",
//     },
//     {
//         id: "first_name",
//         header: "First Name",
//         accessorKey: "first_name",
//     },
//     {
//         id: "last_name",
//         header: "Last Name",
//         accessorKey: "last_name",
//     },
    
   
//     {
//         id: "post_desc",
//         header: "Post",
//         accessorKey: "post_desc",
//     },
//     {
//         id: "nature_of_post_name",
//         header: "Nature of Post",
//         accessorKey: "nature_of_post_name",
//     },
//     {
//         id: "qualification",
//         header: "Qualification",
//         accessorKey: "qualification",
//     },
//     // {
//     //     id: "payscale_type",
//     //     header: "Pay Scale Type",
//     //     accessorKey: "payscale_type",
//     // },
    
    
//     {
//         id: "basicpay",
//         header: "Basic Pay (₹)",
//         accessorKey: "basicpay",
//     },
   
//     {
//         id: "doj",
//         header: "Date of Joining",
//         accessorKey: "doj",
//     },
//     {
//         id: "dob",
//         header: "Date of Birth",
//         accessorKey: "dob",
//     },
    
//     {
//         id: "distname",
//         header: "District",
//         accessorKey: "distname",
//     },
//     {
//         id: "caste_desc",
//         header: "Caste",
//         accessorKey: "caste_desc",
//     },
//     {
//         id: "text",
//         header: "Marital Status",
//         accessorKey: "text",
//     },
//     {
//         id: "father_name",
//         header: "Father Name",
//         accessorKey: "father_name",
//     },
//     {
//         id: "spouse_name",
//         header: "Spouse Name",
//         accessorKey: "spouse_name",
//     },
//     {
//         id: "mobile",
//         header: "Mobile",
//         accessorKey: "mobile",
//     },
   
// ];

//     // Navigation between dashboard levels
//     function handleBack() {
//         if (selectedCollege) {
//             // Level 3 -> Level 2
//             setSelectedCollege(null);
//             setSelectedEmpType('');
//             setEmployeeDetails([]);
//         } else if (selectedUniversity) {
//             // Level 2 -> Level 1
//             setSelectedUniversity(null);
//             setCollegeDashboard([]);
//         }
//     }

//     const isEmployeeLevel = Boolean(selectedCollege);
//     const isCollegeLevel = Boolean(selectedUniversity) && !selectedCollege;

//     return (
//         <div className="faculty-card">
//             <div className="fac-topbar">
//                 <div className="fac-detnew">
//                     <h5 className="mb-0">
//                         {isEmployeeLevel
//                             ? `${selectedEmpType === 'teaching'
//                                 ? 'Teaching'
//                                 : 'Non-Teaching'} Employee Details`
//                             : isCollegeLevel
//                                 ? 'University College Dashboard'
//                                 : 'Faculty Dashboard'}
//                     </h5>
//                 </div>

//                 {(selectedUniversity || selectedCollege) && (
//                     <button
//                         type="button"
//                         className="faculty-back-btn"
//                         onClick={handleBack}
//                     >
//                         <FaArrowLeft size={13} />
//                         {isEmployeeLevel
//                             ? 'Back to Colleges'
//                             : 'Back to Dashboard'}
//                     </button>
//                 )}
//             </div>

//             {/* LEVEL 1: University dashboard */}
//             {!selectedUniversity && !selectedCollege && (
//                 loading ? (
//                     <div className="faculty-empty-state">
//                         Loading university dashboard...
//                     </div>
//                 ) : dashboard.length > 0 ? (
//                     <CommonReactTable
//                         data={dashboard}
//                         columns={columns}
//                         headerName="Faculty Dashboard"
//                         showFooter={false}
//                         showPagination={true}
//                         showExcel={true}
//                         showPrint={true}
//                         excelFileName="Faculty_Dashboard"
//                     />
//                 ) : (
//                     <div className="faculty-empty-state">
//                         <div style={{ fontSize: '42px', opacity: 0.3 }}>
//                             📋
//                         </div>
//                         <p>No Data Found</p>
//                     </div>
//                 )
//             )}

//             {/* LEVEL 2: College dashboard */}
//             {isCollegeLevel && (
//                 <>
//                     <div className="faculty-selected-university">
//                         <span>
//                             <strong>University:</strong>{' '}
//                             {selectedUniversity.univ_name || '-'}
//                         </span>
                       
//                     </div>

//                     {loading ? (
//                         <div className="faculty-empty-state">
//                             Loading college details...
//                         </div>
//                     ) : collegeDashboard.length > 0 ? (
//                         <CommonReactTable
//                             data={collegeDashboard}
//                             columns={collegeColumns}
//                             headerName="College Faculty Details"
//                             showFooter={false}
//                             showPagination={true}
//                             showExcel={true}
//                             showPrint={true}
//                             excelFileName="College_Faculty_Details"
//                         />
//                     ) : (
//                         <div className="faculty-empty-state">
//                             <div style={{ fontSize: '42px', opacity: 0.3 }}>
//                                 📋
//                             </div>
//                             <p>No College Data Found</p>
//                         </div>
//                     )}
//                 </>
//             )}

//             {/* LEVEL 3: Employee details */}
//             {isEmployeeLevel && (
//                 <>
//                     <div className="faculty-selected-university">
//                         <span>
//                             <strong>University:</strong>{' '}
//                             {selectedUniversity?.univ_name || '-'}
//                         </span>
//                         <span>
//                             <strong>College:</strong>{' '}
//                             {selectedCollege.coll_name || '-'}
//                         </span>
                        
//                     </div>

//                     {loading ? (
//                         <div className="faculty-empty-state">
//                             Loading employee details...
//                         </div>
//                     ) : employeeDetails.length > 0 ? (
//                         <CommonReactTable
//                             data={employeeDetails}
//                             columns={employeeColumns}
//                             headerName="Employee Details"
//                             showFooter={false}
//                             showPagination={true}
//                             showExcel={true}
//                             showPrint={true}
//                             excelFileName="Faculty_Employee_Details"
//                         />
//                     ) : (
//                         <div className="faculty-empty-state">
//                             <div style={{ fontSize: '42px', opacity: 0.3 }}>
//                                 📋
//                             </div>
//                             <p>No Employee Data Found</p>
//                         </div>
//                     )}
//                 </>
//             )}
//         </div>
//     );
// }


import React, { useEffect, useState } from 'react';
import { config } from '../CommonUtils/CommonURLS';
import { CommonAxiosGet } from '../CommonUtils/CommonAxios';
import CommonReactTable from '../CommonUtils/CommonReactTable';
import { FaArrowLeft, FaUsers } from 'react-icons/fa';

// Small inline style for the "code" shown beside a name
const codeStyle = {
    marginLeft: '6px',
    padding: '1px 8px',
    borderRadius: '10px',
    background: '#eef3f9',
    color: '#1a3a5c',
    fontSize: '12px',
    fontWeight: '600',
};

export default function FacultyDashboardReport() {
    const userId = sessionStorage.getItem("user_id");

    // University login (e.g. "U-0003_admin") -> key = "U-0003", skip level 1
    const isUnivLogin = Boolean(userId?.startsWith("U-"));
    const key = isUnivLogin ? userId.split("_")[0] : "all";

    console.log("API Key:", key);

    const [dashboard, setDashboard] = useState([]);
    const [collegeDashboard, setCollegeDashboard] = useState([]);
    const [employeeDetails, setEmployeeDetails] = useState([]);

    const [selectedUniversity, setSelectedUniversity] = useState(null);
    const [selectedCollege, setSelectedCollege] = useState(null);
    const [selectedEmpType, setSelectedEmpType] = useState('');

    const [loading, setLoading] = useState(false);

    // LEVEL 1: University dashboard
    function GetDashboardData() {
        setLoading(true);

        CommonAxiosGet(
            `${config.url.FAC_URL}getunivdashboard/${key}`
        )
            .then((res) => {
                setDashboard(
                    res?.data?.scode === '01'
                        ? res.data.data || []
                        : []
                );
            })
            .catch((error) => {
                console.error('Error fetching university dashboard:', error);
                setDashboard([]);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    // University login: fetch own university row (for name + aishe code),
    // then open the college level (level 2) directly.
    function InitUniversityLogin() {
        setLoading(true);

        CommonAxiosGet(
            `${config.url.FAC_URL}getunivdashboard/${key}`
        )
            .then((res) => {
                const rows = res?.data?.scode === '01' ? res.data.data || [] : [];
                const univ =
                    rows.find((r) => String(r.aishe_code) === String(key)) ||
                    rows[0] ||
                    {};
                GetCollegeDashboard({ ...univ, aishe_code: univ.aishe_code || key });
            })
            .catch((error) => {
                console.error('Error fetching university details:', error);
                GetCollegeDashboard({ aishe_code: key });
            });
    }

    useEffect(() => {
        if (isUnivLogin) {
            InitUniversityLogin();
        } else {
            GetDashboardData();
        }
    }, []);

    // LEVEL 2: College dashboard
    function GetCollegeDashboard(university) {
        const ubCode = university?.aishe_code;

        if (!ubCode) {
            alert('AISHE Code is not available for this university.');
            return;
        }

        setSelectedUniversity(university);
        setSelectedCollege(null);
        setSelectedEmpType('');
        setCollegeDashboard([]);
        setEmployeeDetails([]);
        setLoading(true);

        CommonAxiosGet(
            `${config.url.FAC_URL}getunivdashboardcollges/${encodeURIComponent(ubCode)}`
        )
            .then((res) => {
                setCollegeDashboard(
                    res?.data?.scode === '01'
                        ? res.data.data || []
                        : []
                );
            })
            .catch((error) => {
                console.error('Error fetching college dashboard:', error);
                setCollegeDashboard([]);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    // LEVEL 3: Employee details by college and employee type
    function GetCollegeEmployees(college, empType) {
        console.log("ddddddddd", college, empType);
        const collCode = college?.coll_code;

        if (!collCode) {
            alert('College code is not available.');
            console.error('Selected college data:', college);
            return;
        }

        setSelectedCollege(college);
        setSelectedEmpType(empType);
        setEmployeeDetails([]);
        setLoading(true);

        CommonAxiosGet(
            `${config.url.FAC_URL}getunivdashboadcollegesemployees/${encodeURIComponent(collCode)}/${empType}`
        )
            .then((res) => {
                setEmployeeDetails(
                    res?.data?.scode === '01'
                        ? res.data.data || []
                        : []
                );
            })
            .catch((error) => {
                console.error('Error fetching employee details:', error);
                setEmployeeDetails([]);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    // LEVEL 1: University columns
    const columns = [
        {
            id: 'slNo',
            header: 'Sl.No',
            cell: ({ row }) => row.index + 1,
        },
        {
            id: 'univ_name',
            header: 'University Name',
            accessorKey: 'univ_name',
            cell: ({ row }) =>
                `${row.original.univ_name || '-'}${row.original.aishe_code ? ` - ${row.original.aishe_code}` : ''}`,
        },
        {
            id: 'teaching',
            header: 'Teaching Faculty',
            accessorKey: 'teaching',
            cell: ({ row }) => (
                <button
                    type="button"
                    className="faculty-count-btn teaching-count"
                    onClick={() => GetCollegeDashboard(row.original)}
                    title="View college-wise teaching faculty counts"
                >
                    <FaUsers size={13} />
                    {row.original.teaching ?? 0}
                </button>
            ),
            meta: { style: { textAlign: 'center' } },
        },
        {
            id: 'nonteaching',
            header: 'Non-Teaching Faculty',
            accessorKey: 'nonteaching',
            cell: ({ row }) => (
                <button
                    type="button"
                    className="faculty-count-btn nonteaching-count"
                    onClick={() => GetCollegeDashboard(row.original)}
                    title="View college-wise non-teaching faculty counts"
                >
                    <FaUsers size={13} />
                    {row.original.nonteaching ?? 0}
                </button>
            ),
            meta: { style: { textAlign: 'center' } },
        },
    ];

    // LEVEL 2: College columns
    const collegeColumns = [
        {
            id: 'slNo',
            header: 'Sl.No',
            cell: ({ row }) => row.index + 1,
        },
        {
            id: 'coll_name',
            header: 'College Name',
            accessorKey: 'coll_name',
            cell: ({ row }) =>
                `${row.original.coll_name || '-'}${row.original.coll_code ? ` - ${row.original.coll_code}` : ''}`,
        },
        {
            id: 'teaching',
            header: 'Teaching Faculty',
            accessorKey: 'teaching',
            cell: ({ row }) => (
                <button
                    type="button"
                    className="faculty-count-btn teaching-count"
                    onClick={() =>
                        GetCollegeEmployees(row.original, 'teaching')
                    }
                    title="View teaching employees"
                >
                    <FaUsers size={13} />
                    {row.original.teaching ?? 0}
                </button>
            ),
            meta: { style: { textAlign: 'center' } },
        },
        {
            id: 'nonteaching',
            header: 'Non-Teaching Faculty',
            accessorKey: 'nonteaching',
            cell: ({ row }) => (
                <button
                    type="button"
                    className="faculty-count-btn nonteaching-count"
                    onClick={() =>
                        GetCollegeEmployees(row.original, 'nonteaching')
                    }
                    title="View non-teaching employees"
                >
                    <FaUsers size={13} />
                    {row.original.nonteaching ?? 0}
                </button>
            ),
            meta: { style: { textAlign: 'center' } },
        },
    ];

    // LEVEL 3: Employee columns
    // Adjust accessor keys if the employee API returns different field names.
    const employeeColumns = [
        {
            id: "slNo",
            header: "Sl. No.",
            cell: ({ row }) => row.index + 1,
        },
        {
            id: "description_long",
            header: "University",
            accessorKey: "description_long",
        },
        {
            id: "cfms_id",
            header: "CFMS ID",
            accessorKey: "cfms_id",
        },
        {
            id: "first_name",
            header: "First Name",
            accessorKey: "first_name",
        },
        {
            id: "last_name",
            header: "Last Name",
            accessorKey: "last_name",
        },
        {
            id: "post_desc",
            header: "Post",
            accessorKey: "post_desc",
        },
        {
            id: "nature_of_post_name",
            header: "Nature of Post",
            accessorKey: "nature_of_post_name",
        },
        {
            id: "qualification",
            header: "Qualification",
            accessorKey: "qualification",
        },
        // {
        //     id: "payscale_type",
        //     header: "Pay Scale Type",
        //     accessorKey: "payscale_type",
        // },
        {
            id: "basicpay",
            header: "Basic Pay (₹)",
            accessorKey: "basicpay",
        },
        {
            id: "doj",
            header: "Date of Joining",
            accessorKey: "doj",
        },
        {
            id: "dob",
            header: "Date of Birth",
            accessorKey: "dob",
        },
        {
            id: "distname",
            header: "District",
            accessorKey: "distname",
        },
        {
            id: "caste_desc",
            header: "Caste",
            accessorKey: "caste_desc",
        },
        {
            id: "text",
            header: "Marital Status",
            accessorKey: "text",
        },
        {
            id: "father_name",
            header: "Father Name",
            accessorKey: "father_name",
        },
        {
            id: "spouse_name",
            header: "Spouse Name",
            accessorKey: "spouse_name",
        },
        {
            id: "mobile",
            header: "Mobile",
            accessorKey: "mobile",
        },
    ];

    // Navigation between dashboard levels
    function handleBack() {
        if (selectedCollege) {
            // Level 3 -> Level 2
            setSelectedCollege(null);
            setSelectedEmpType('');
            setEmployeeDetails([]);
        } else if (selectedUniversity && !isUnivLogin) {
            // Level 2 -> Level 1 (not available for university login)
            setSelectedUniversity(null);
            setCollegeDashboard([]);
        }
    }

    const isEmployeeLevel = Boolean(selectedCollege);
    const isCollegeLevel = Boolean(selectedUniversity) && !selectedCollege;

    // University login has no level 1, so hide "Back to Dashboard" at level 2
    const showBackBtn = isEmployeeLevel || (isCollegeLevel && !isUnivLogin);

    return (
        <div className="faculty-card">
            <div className="fac-topbar">
                <div className="fac-detnew">
                    <h5 className="mb-0">
                        {isEmployeeLevel
                            ? `${selectedEmpType === 'teaching'
                                ? 'Teaching'
                                : 'Non-Teaching'} Employee Details`
                            : isCollegeLevel || isUnivLogin
                                ? 'University College Dashboard'
                                : 'Faculty Dashboard'}
                    </h5>
                </div>

                {showBackBtn && (
                    <button
                        type="button"
                        className="faculty-back-btn"
                        onClick={handleBack}
                    >
                        <FaArrowLeft size={13} />
                        {isEmployeeLevel
                            ? 'Back to Colleges'
                            : 'Back to Dashboard'}
                    </button>
                )}
            </div>

            {/* University login: waiting for level 2 to open */}
            {isUnivLogin && !selectedUniversity && (
                <div className="faculty-empty-state">
                    {loading ? 'Loading college details...' : 'No Data Found'}
                </div>
            )}

            {/* LEVEL 1: University dashboard (not for university login) */}
            {!isUnivLogin && !selectedUniversity && !selectedCollege && (
                loading ? (
                    <div className="faculty-empty-state">
                        Loading university dashboard...
                    </div>
                ) : dashboard.length > 0 ? (
                    <CommonReactTable
                        data={dashboard}
                        columns={columns}
                        headerName="Faculty Dashboard"
                        showFooter={false}
                        showPagination={true}
                        showExcel={true}
                        showPrint={true}
                        excelFileName="Faculty_Dashboard"
                    />
                ) : (
                    <div className="faculty-empty-state">
                        <div style={{ fontSize: '42px', opacity: 0.3 }}>
                            📋
                        </div>
                        <p>No Data Found</p>
                    </div>
                )
            )}

            {/* LEVEL 2: College dashboard */}
            {isCollegeLevel && (
                <>
                    <div className="faculty-selected-university">
                        <span>
                            <strong>University:</strong>{' '}
                            {selectedUniversity.univ_name || '-'}
                            <span style={codeStyle}>
                                AISHE Code: {selectedUniversity.aishe_code || '-'}
                            </span>
                        </span>
                    </div>

                    {loading ? (
                        <div className="faculty-empty-state">
                            Loading college details...
                        </div>
                    ) : collegeDashboard.length > 0 ? (
                        <CommonReactTable
                            data={collegeDashboard}
                            columns={collegeColumns}
                            headerName="College Faculty Details"
                            showFooter={false}
                            showPagination={true}
                            showExcel={true}
                            showPrint={true}
                            excelFileName="College_Faculty_Details"
                        />
                    ) : (
                        <div className="faculty-empty-state">
                            <div style={{ fontSize: '42px', opacity: 0.3 }}>
                                📋
                            </div>
                            <p>No College Data Found</p>
                        </div>
                    )}
                </>
            )}

            {/* LEVEL 3: Employee details */}
            {isEmployeeLevel && (
                <>
                    <div className="faculty-selected-university">
                        <span>
                            <strong>University:</strong>{' '}
                            {selectedUniversity?.univ_name || '-'}
                            <span style={codeStyle}>
                                AISHE Code: {selectedUniversity?.aishe_code || '-'}
                            </span>
                        </span>
                        <span>
                            <strong>College:</strong>{' '}
                            {selectedCollege.coll_name || '-'}
                            <span style={codeStyle}>
                                College Code: {selectedCollege.coll_code || '-'}
                            </span>
                        </span>
                    </div>

                    {loading ? (
                        <div className="faculty-empty-state">
                            Loading employee details...
                        </div>
                    ) : employeeDetails.length > 0 ? (
                        <CommonReactTable
                            data={employeeDetails}
                            columns={employeeColumns}
                            headerName="Employee Details"
                            showFooter={false}
                            showPagination={true}
                            showExcel={true}
                            showPrint={true}
                            excelFileName="Faculty_Employee_Details"
                        />
                    ) : (
                        <div className="faculty-empty-state">
                            <div style={{ fontSize: '42px', opacity: 0.3 }}>
                                📋
                            </div>
                            <p>No Employee Data Found</p>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}